/**
 * @generated SignedSource<<028c7fa2238ff44f82d71cf8129c39f6>>
 * @relayHash 06566dc21293179b811e47ec5f92c1f1
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 06566dc21293179b811e47ec5f92c1f1

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "TokenResponse",
    "kind": "LinkedField",
    "name": "makeDuplicata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MakeDuplicataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MakeDuplicataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "06566dc21293179b811e47ec5f92c1f1",
    "metadata": {},
    "name": "MakeDuplicataMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "fb8e9d7fccc805db1257d2e4ddc38a3f";

export default node;
